import {
  LandingCompanyIdEnum,
  LandingCompanyNameEnum,
} from "../enums/landing-company.enum";
import { ILandingRouteMapperItem } from "../models";

//todo- move to table
export const landingRouteMapper: ILandingRouteMapperItem[] = [
  {
    companyId: LandingCompanyIdEnum.Herzliya,
    path: LandingCompanyNameEnum.Herzliya,
  },
  { companyId: LandingCompanyIdEnum.Clal, path: LandingCompanyNameEnum.Clal },
  { companyId: LandingCompanyIdEnum.Tnufa, path: LandingCompanyNameEnum.Tnufa },
  {
    companyId: LandingCompanyIdEnum.WestNegev,
    path: LandingCompanyNameEnum.WestNegev,
  },
  {
    companyId: LandingCompanyIdEnum.NvidiaShuttle,
    path: LandingCompanyNameEnum.NvidiaShuttle,
  },
  {
    companyId: LandingCompanyIdEnum.Wix,
    path: LandingCompanyNameEnum.Wix,
  },
];
